import { render } from "./Specials.vue?vue&type=template&id=57b815bc"
import script from "./Specials.vue?vue&type=script&lang=js"
export * from "./Specials.vue?vue&type=script&lang=js"

import "./Specials.vue?vue&type=style&index=0&id=57b815bc&lang=css"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__